import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { SeguroAdesaoServices } from 'src/app/services/seguro/seguro-adesao.service';
import { CurrencyPipe } from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
    selector: 'app-comp-simulador-seguro',
    templateUrl: './comp-simulador-seguro.component.html',
    styleUrls: ['./comp-simulador-seguro.component.css'],
    imports: [CommonModule, CurrencyPipe, FormsModule, ReactiveFormsModule],
    providers: [SeguroAdesaoServices]
})
export class CompSimuladorSeguroComponent implements OnInit {

  loading: boolean = true;

  coberturaMorte: number = 20000.00;
  coberturaInvalidez: number = 20000.00;

  fatorMorte: number;
  fatorInvalidez: number;

  premioMorte: number = 0;
  premioInvalidez: number = 0;
  premioTotal: number = 0;

  idcCobMorte: boolean = true;
  idcCobInvalidez: boolean = true;

  idcDisCobMorte: boolean = false;
  idcDisCobInvalidez: boolean = false;

  coberturaMorteDisponivel: number = 1000000;
  coberturaInvalidezDisponivel: number = 1000000;

  constructor(private seguroAdesao: SeguroAdesaoServices) { }

  ngOnInit() {

  }

  init(){
    if(this.coberturaMorteDisponivel < 20000){
      this.idcCobMorte=false;
      this.idcDisCobMorte=true;
    }

    if(this.coberturaInvalidezDisponivel < 20000){
      this.idcCobInvalidez=false;
      this.idcDisCobInvalidez=true;
    }
  }

  carregarFatoresDeCalculo(idade: number){

    this.loading = true;

    this.seguroAdesao
        .fatoresDeCalculo(idade)
        .pipe(
          finalize(() => this.loading = false)
        )
        .subscribe(
          (res: any) => {
            this.fatorMorte = res.fatorMorte;
            this.fatorInvalidez = res.fatorInvalidez;

            this.calcularPremioMorte();
            this.calcularPremioInvalidez();
          },
          (httpError: HttpErrorResponse) => {

          }
        )
  }

  calcularPremioMorte(){

    if(this.idcCobMorte){
      this.premioMorte = parseFloat((this.fatorMorte/1000 * this.coberturaMorte).toFixed(2));
      this.calcularPremioTotal();
    }else{
      this.premioMorte = 0;
    }
  }

  calcularPremioInvalidez(){

    if(this.idcCobInvalidez){
      this.premioInvalidez = parseFloat((this.fatorInvalidez/1000 * this.coberturaInvalidez).toFixed(2));
      this.calcularPremioTotal()
    }else{
      this.premioInvalidez = 0;
    }
  }

  calcularPremioTotal(){

    this.premioTotal = 0;

    if(this.idcCobMorte){
      this.premioTotal+= this.premioMorte;
    }

    if(this.idcCobInvalidez){
      this.premioTotal += this.premioInvalidez;
    }
  }

  onCoberturaChange(){
    this.calcularPremioMorte();
    this.calcularPremioInvalidez();
  }


}
